import ImgComponent from './imgAllFunctionDig.vue'

const imgBox = {};
// extend 这个也可以用 但是
//在 SSR 环境（服务端渲染），通过 Vue.extend 和 new Vue 构造来生成的组件实例，是编译不过的

// imgBox.install = (Vue) => {
//   // 使用基础 Vue 构造器
//   const ImgConstructor = Vue.extend(ImgComponent);
//   const instance = new ImgConstructor();
//   // 挂载
//   instance.$mount();
//   document.body.appendChild(instance.$el);
//   // 添加实例方法，以供全局调用list[{id:}]全部图片，id选中的图片
//   Vue.prototype.$showPic = (list,id) => {
//     instance.add(list,id)
//   }
// };

// render 试一下
imgBox.install = (Vue) => {
  // 应该要使用单例
  let singleInstance;
  ImgComponent.newInstance = properties => {
    const props = properties || {};
    // new过了
    const Instance = new Vue({
      data: props,
      render (h) {
        return h(ImgComponent, {
          props: props
        });
      }
    });

    const component = Instance.$mount();
    document.body.appendChild(component.$el);
    const insvue = Instance.$children[0]; //拿到vue实例
    return {
      // 添加实例方法，以供全局调用
      // params
      // 全部图片
      // list[{id:'123'},{id:'123455'}]
      // id:123
      // 选中的图片
      add (list=[],id) {
        insvue.add(list,id)
      },
      addNormal(list=[],id) {
        insvue.addNormal(list,id)
      },
      addFullURL(url) { //非id,完整url
        insvue.addFullURL(url)
      },
    }
  }
  singleInstance = singleInstance||ImgComponent.newInstance()
  // ImgComponent.newInstance(properties) 可以传入props对象

  Vue.prototype.$showPic = singleInstance.add //发票类图片id查看
  Vue.prototype.$showPicNormal = singleInstance.addNormal  //一般图片id查看
  Vue.prototype.$addFullURL = singleInstance.addFullURL  //一般图片传入完整url查看
};
export default imgBox;
